import React from "react";
import SelectListWithSearch from "../../../../components/UI/FormInputs/SelectListWithSearch";
import CheckboxInput from "../../../../components/UI/FormInputs/Checkbox";

const SearchHistory = (props) => {
  const {
    checkedHistoryId,
    activeSearchSource,
    overallSearch,
    fetchMatchFiels,
    setActiveSearchSource,
    setIsSearchFromDropdown,
    SetOverallSearch,
    handleHistoryClick,
    currentSearchLabel,
    setCheckedHistoryId,
    setSearchTerm,
    setHighlightTerm,
    setCurrentSearchLabel,
    fetchEmrList,
    handleSearch,
    historyRef,
    recommendedActivities,
    isSearchFromDropdown,
    checkHandle,
  } = props;
  return (
    <div className="col-3">
      <div className="sh_emrcardrow">
        <div className="sh_emrfieldcardbox mb-0 sh_cardBox">
          <div className="sh_emrcardHead sh_cardHeader p-2">
            <div className="form-group mb-1">
              <h6 className="text-sm font-weight-bold d-flex mb-0">
                Search All / History
              </h6>
            </div>
            <div className="form-group mb-1">
              <div
                title={
                  checkedHistoryId ? "Uncheck history item to search again" : ""
                }
              >
                <SelectListWithSearch
                  placeholder="Search Here..."
                  name="overallSearch"
                  className={"form-control form-control-solid"}
                  readOnly={
                    activeSearchSource === "history" ||
                    activeSearchSource === "field"
                  }
                  value={overallSearch}
                  isAsync={true}
                  loadCallBack={(val, callback) =>
                    fetchMatchFiels(val, callback)
                  }
                  isCacheNeeded={false}
                  // reload={overallSearch}
                  changeHandler={(selected) => {
                    if (selected) {
                      setActiveSearchSource("selectlist");
                      setIsSearchFromDropdown(true);
                      // fetchEmrList();
                      SetOverallSearch(selected); // display label
                      handleHistoryClick(selected); // logic
                    }
                  }}
                />
              </div>
              {currentSearchLabel && (
                <div className="mt-2 px-2 d-flex justify-content-between align-items-center text-center">
                  <div className="badge bg-light forTable_textEllipsis text-dark mb-0  px-3 py-2 w-100">
                    🔍 {currentSearchLabel}
                  </div>
                  <div className="">
                    <button
                      className="btn btn-sm btn-primary w-100"
                      onClick={() => {
                        SetOverallSearch("");
                        setCheckedHistoryId(null);
                        setSearchTerm("");
                        setHighlightTerm(null);
                        setActiveSearchSource(null);
                        setCurrentSearchLabel("");
                        setIsSearchFromDropdown(false);
                        fetchEmrList();
                        handleSearch();
                      }}
                    >
                      Clear
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="sh_emrcardHead sh_cardHeader sh_pbrhead p-1">
            <h6
              className="font-weight-bold mb-0"
              style={{ fontSize: "0.65rem" }}
            >
              Recent Search History
            </h6>
          </div>

          <div className="sh_emrcardBody sh_cardBody py-1" ref={historyRef}>
            {recommendedActivities.map(({ id, label }) => (
              <div className="row" key={id}>
                <div className="col-1">
                  <CheckboxInput
                    label="Required"
                    className="form-check mb-0"
                    value={checkedHistoryId === id}
                    name="is_required"
                    id={id}
                    readOnly={
                      isSearchFromDropdown ||
                      activeSearchSource === "selectlist" ||
                      activeSearchSource === "field" ||
                      (checkedHistoryId !== null && checkedHistoryId !== id)
                    }
                    changeHandler={(val, e) => {
                      checkHandle(val, e, id, label);
                    }}
                  />
                </div>
                <div className="col-10 d-flex align-items-center">
                  <label
                    className="formlabel mb-0"
                    htmlFor={id}
                    onClick={(e) => e.stopPropagation()}
                  >
                    {label}
                  </label>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchHistory;
